<template>
  <main class="school-page small-scroll-bar small-scroll-bar--black">
    <lazy-hydrate when-visible>
      <school-new-banner
        :title="`домашняя школа для ${pageClass}&nbsp;класса`"
        :page-class="pageClass"
      />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <main-certificate />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <school-new-schedule :page-class="pageClass" />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <div class="why__title">
        <div class="main-title">
          <h2>почему нас выбирают?</h2>
        </div>
        <school-new-choose />
        <school-new-goal />
      </div>
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <school-tariffs />
    </lazy-hydrate>

    <!--<lazy-hydrate when-visible>-->
    <!--  <school-new-quality />-->
    <!--</lazy-hydrate>-->

    <lazy-hydrate when-visible>
      <!-- eslint-disable vue/max-len -->
      <su-team
        title="<h2>обучайтесь комфортно дома <span>с&nbsp;помощью лучших специалистов</span></h2>"
        class="school-page__team"
      />
      <!-- eslint-enable -->
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <school-new-support />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <su-reviews />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <su-faq />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <school-new-form />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <main-necessary title="<h2>учитесь с удовольствием</h2>" />
    </lazy-hydrate>

    <lazy-hydrate when-visible>
      <school-new-breadcrumbs :breadcrumbs="breadcrumbs" />
    </lazy-hydrate>
  </main>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration';
import HeadMixin from '@/mixins/HeadMixin';

const SchoolNewBanner = () => import('~/components/v2/school-new/SchoolNewBanner.vue');
const SuReviews = () => import('~/components/v2/school-university/SuReviews.vue');
const MainNecessary = () => import('~/components/v2/main/MainNecessary.vue');
const SuFaq = () => import('~/components/v2/school-university/SuFaq.vue');
const SchoolNewChoose = () => import('~/components/v2/school-new/SchoolNewChoose.vue');
const SchoolNewGoal = () => import('~/components/v2/school-new/SchoolNewGoal.vue');
const SchoolNewSchedule = () => import('~/components/v2/school-new/SchoolNewSchedule.vue');
// const SchoolNewQuality = () => import('../../c~s/v2/school-new/SchoolNewQuality.vue');
const SuTeam = () => import('~/components/v2/school-university/SuTeam.vue');
const SchoolNewForm = () => import('~/components/v2/school-new/SchoolNewForm.vue');
const SchoolNewSupport = () => import('~/components/v2/school-new/SchoolNewSupport.vue');
const SchoolNewBreadcrumbs = () => import('~/components/v2/school-new/SchoolNewBreadcrumbs.vue');
const SchoolTariffs = () => import('~/components/v2/school-new/SchoolTariffs.vue');
const MainCertificate = () => import('~/components/v2/main/MainCertificate.vue');

export default {
  name: 'OnlineSchoolKlass',
  components: {
    LazyHydrate,
    SchoolTariffs,
    SchoolNewBreadcrumbs,
    SchoolNewSupport,
    SchoolNewForm,
    SuTeam,
    // SchoolNewQuality,
    SchoolNewSchedule,
    SchoolNewGoal,
    SchoolNewChoose,
    SuFaq,
    MainNecessary,
    SuReviews,
    SchoolNewBanner,
    MainCertificate,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',

  props: {
    pageClass: {
      type: Number,
      default: 5,
    },
  },

  computed: {
    breadcrumbs() {
      return [
        { text: 'главная', to: '/' },
        { text: 'домашняя школа', to: '/online-school' },
        { text: `${this.pageClass} класс`, to: `/online-school/${this.pageClass}-klass` },
      ];
    },

    // для head
    title() {
      return `Домашняя школа ${this.pageClass} класс | дистанционное обучение в ШУ Синергия`;
    },
    description() {
      // eslint-disable-next-line max-len,vue/max-len
      return `Онлайн-школа для ${this.pageClass} класса с лицензией и гос. аттестацией. Подготовка к ЕГЭ и ОГЭ, индивидуальные программы, IT-курсы для школьников. Начните обучение сегодня!`;
    },
    image() {
      return `/v2/school-new/${this.pageClass}/share-image.jpg`;
    },
  },
};
</script>

<style scoped lang="scss">

.school-page {
  padding-top: calc(var(--scale) * 120);
  padding-bottom: calc(var(--scale) * 58);
  padding-inline: calc(var(--scale) * 40);
  background-color: #ECEDF0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 128);

  @include media-down($size-tablet) {
    padding-inline: calc(var(--scale) * 16);
    padding-bottom: calc(var(--scale) * 24);
    gap: calc(var(--scale) * 76);
  }

  @include media-down($size-mobile) {
    padding-inline: calc(var(--scale) * 12);
  }

  ::v-deep(*) {
    font-family: "Onest", sans-serif;
  }

  ::v-deep(.main-title) {
    position: relative;
    font-family: 'Onest', sans-serif;

    p {
      position: absolute;
      left: 0;
      top: 1.25rem;

      font-weight: 500;
      font-size: 1.625rem;
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 18);
      }

      @include media-down($size-mobile) {
        position: relative;
        top: 0;
        margin-bottom: -0.2rem;
      }

      & + h2 {
        text-indent: calc(var(--scale) * 465);

        @include media-down($size-tablet) {
          text-indent: calc(var(--scale) * 186);
        }

        @include media-down($size-mobile) {
          text-indent: 0;
        }
      }
    }

    h2 {
      font-weight: 500;
      font-size: 5.375rem;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 40);
      }

      span {
        color: #A7ABAC;
      }
    }
  }

  .why__title .main-title,
  .school-page__team ::v-deep(.main-title) {
    margin-bottom: calc(var(--scale) * 40);

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 24);
    }

    span {
      display: block;
    }
  }

  ::v-deep(.main-goal) .main-goal__block {
    margin-top: calc(var(--scale) * 20);
    margin-bottom: 0;
  }

  ::v-deep(.synergy-friends) {
    margin-bottom: 0;
  }
}

</style>
